import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const WeldHeaderStyled = styled(Box).attrs({ px: { sm: '550' }, pt: { sm: '550' }, pb: { sm: '500' } })`
  background-image: linear-gradient(275deg, rgb(24, 37, 42), rgb(41, 71, 81));
  box-shadow: rgb(0 0 0 / 20%) 0px 1px 8px 0px, rgb(0 0 0 / 12%) 0px 3px 3px -2px, rgb(0 0 0 / 14%) 0px 3px 4px 0px;
  z-index: 1;
`;
